import styled from 'styled-components';

export const RecentSearchOuterWrapper = styled.section(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
  `,
);

export const SliderHeaderArrowWrapper = styled.div(
  props => `
    width: 20%;
    display: flex;
    justify-content: flex-end;
    padding-right: ${props.theme.spacing.large.l20};
    align-self: flex-end;
  `,
);

export const SliderHeaderArrowWrapInner = styled.div(
  props => `
    width: 7.5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0.1rem 0.4rem 0 ${props.theme.colors.shadow.light};
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.custom(20)}
  `,
);

export const SliderArrowWrap = styled.a(
  props => `
    padding: ${props.theme.spacing.base};
    cursor: pointer;
    font-size: ${props.theme.font.base};
    color: ${props.theme.colors.goBrand.blue};
    display: inline-flex;
    background:${props.theme.colors.white.base};
    border-radius:50%;
    &:hover{
        color: ${props.theme.colors.goBrand.blue};
    }
  `,
);

export const RecentSearchSlider = styled.div(
  props => `
        width:100%;
        display: flex;
        overflow: hidden;
        padding-top: ${props.theme.spacing.large.l20};
        padding-bottom: ${props.theme.spacing.small.s5};
        height: 13rem;
    `,
);

export const RecentSearchInnerWrap = styled.div(
  props => `
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.nospacing} ${props.theme.spacing.small.s5};
  `
);

export const RecentSearchHeadText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      color: ${props.theme.colors.grey.base};
  `
);

export const RecentSearchListWrap = styled.ul(
  props => `
    display: flex;
    list-style-type: none;
    padding-left: ${props.theme.spacing.large.l20};
    
    li{
      width: 170px;
      padding: ${props.theme.spacing.small.s6} ${props.theme.spacing.large.l11};
      display: flex;
      flex-direction: column;
      border-radius: ${props.theme.misc.borderRadius.base};
      box-shadow: 0 1px 4px 0 ${props.theme.colors.black.light2};
      background-color: ${props.theme.colors.grey.lightf2};
      margin-right: ${props.theme.spacing.base};
      cursor: pointer;

      p{
          font-size: ${props.theme.font.base};
          font-weight: ${props.theme.font.fontWeight.bold};
          color: ${props.theme.colors.black.base};
          text-transform: ${props.theme.font.textTransform.capital};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
      }
      span{
          font-size: ${props.theme.font.small.font10};
          color: ${props.theme.colors.black.base};
      }
    }
  `
);
